<div *ngIf="Enabled">
  <div class="row">
    <div class="col-md-12">
      <div class="form-group" *ngIf="CanCancelOutboundReceipts=='True'">

        <input (change)="emitSetttings()"
               type="checkbox"
               [ngModel]="defaultSettings?.CanCancelOutboundReceipts"
               (ngModelChange)="defaultSettings.CanCancelOutboundReceipts = $event" />
        <b>{{ 'pages.userModification.userSettings.cashierSettings.cancelShipments' | translate }}</b>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="AllowOutboundDiscount=='True'">
    <div class="col-md-3">
      <div class="form-group">
        <input (change)="emitSetttings()"
               type="checkbox"
               [ngModel]="defaultSettings?.DiscountEnabledOnOutbound"
               (ngModelChange)="defaultSettings.DiscountEnabledOnOutbound = $event" />

        <b>{{ 'pages.userModification.userSettings.cashierSettings.allowOutbountDiscount' | translate }}</b>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-inline">
        <div class="form-group">
          <b>{{ 'pages.userModification.userSettings.cashierSettings.maxDiscountPer' | translate }}</b>
          <div class="inner-addon right-addon" style="padding-left: 15px;">
            <i></i>
            <input type="text"
                   style="width:50%"
                   class="form-control"
                   (blur)="validateMaximumDiscountOutboundpercentage()"
                   [ngModel]="defaultSettings?.MaximumDiscountPercentageOutbound"
                   (ngModelChange)="defaultSettings.MaximumDiscountPercentageOutbound = $event" />
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <span style="color:red" [innerHtml]="MaximumDiscountOutboundpercentageValidationText"></span>
    </div>
  </div>
  <div class="row" *ngIf="AllowInboundDiscount=='True'">
    <div class="col-md-3">
      <div class="form-group">
        <input type="checkbox"
               (change)="emitSetttings()"
               [ngModel]="defaultSettings?.DiscountEnabledOnInbound"
               (ngModelChange)="defaultSettings.DiscountEnabledOnInbound = $event" />
        <b>{{ 'pages.userModification.userSettings.cashierSettings.allowInboundDiscount' | translate }}</b>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-inline">
        <div class="form-group">
          <b>{{ 'pages.userModification.userSettings.cashierSettings.maxDiscountPer' | translate }}</b> &nbsp;
          <div class="inner-addon right-addon">
            <i></i>
            <input type="text" style="width:50%" class="form-control"
                   (change)="emitSetttings()"
                   [ngModel]="defaultSettings?.MaximumDiscountPercentageInbound"
                   (ngModelChange)="defaultSettings.MaximumDiscountPercentageInbound = $event" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">

  </div>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <input type="checkbox"
               (change)="emitSetttings()"
               [ngModel]="defaultSettings?.PaymentDeviceEnabled"
               (ngModelChange)="defaultSettings.PaymentDeviceEnabled = $event" />
        <b>{{ 'pages.userModification.userSettings.cashierSettings.paymentDevice' | translate }}</b>
      </div>
    </div>


    <div *ngIf="defaultSettings.PaymentDeviceEnabled" class="row">

      <div class="col-md-4">
        <div class="form-group">
          <select style="margin-top: 5px;" class="form-control"
                  (change)="emitSetttings()"
                  [ngModel]="defaultSettings?.PaymentDeviceCode"
                  (ngModelChange)="defaultSettings.PaymentDeviceCode = $event">
            <option *ngFor="let device of paymentDevices" value="{{device?.Code}}">{{device?.Name}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <input type="text"
                 style="width:50%"
                 class="form-control"
                 placeholder="{{ 'pages.userModification.userSettings.cashierSettings.paymentDeviceTerminal' | translate }}"
                 (change)="emitSetttings()"
                 [ngModel]="defaultSettings?.PaymentDeviceTerminal"
                 (ngModelChange)="defaultSettings.PaymentDeviceTerminal = $event" />


        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <b> {{ 'pages.userModification.userSettings.cashierSettings.receiptLabelType' | translate }}</b>
        <select class="form-control"
                (change)="emitSetttings()"
                [ngModel]="defaultSettings?.ReceiptType"
                (ngModelChange)="defaultSettings.ReceiptType = $event">
          <option *ngFor="let i of reports?.receiptReport.reports" value="{{i.ReportId}}">{{i.Description}}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <b> {{ 'pages.userModification.userSettings.cashierSettings.taxReceiptLabelType' | translate }}</b>
        <select class="form-control"
                (change)="emitSetttings()"
                [ngModel]="defaultSettings?.TaxInvoiceType"
                (ngModelChange)="defaultSettings.TaxInvoiceType = $event">
          <option *ngFor="let i of reports?.taxInvoicesReport.reports" value="{{i.ReportId}}">{{i.Description}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="CanCancelOutboundReceipts=='True'">
    <div class="col-md-4">
      <div class="form-group">
        <b> {{ 'pages.userModification.userSettings.cashierSettings.waybillForm' | translate }}</b>
        <select class="form-control"
                (change)="emitSetttings()"
                [ngModel]="defaultSettings?.LabelType"
                (ngModelChange)="defaultSettings.LabelType = $event">
          <option *ngFor="let i of reports?.labelReport.reports" value="{{i.ReportId}}">{{i.Description}}</option>
        </select>
      </div>
    </div>
  </div>


  <div class="row" *ngIf="AllowPrintingMultipleLabels">
    <div class="col-md-4">
      <div class="form-group">
        <b>{{ 'pages.userModification.userSettings.cashierSettings.secondWaybillForm' | translate }}</b>
        <select class="form-control"
                (change)="emitSetttings()"
                [ngModel]="defaultSettings?.SecondLabelType"
                (ngModelChange)="defaultSettings.SecondLabelType = $event">
          <option *ngFor="let i of reports?.SecondLabelReport.reports" value="{{i.ReportId}}">{{i.Description}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <b> {{ 'pages.userModification.userSettings.cashierSettings.cashierReport' | translate }}</b>
        <select class="form-control"
                (change)="emitSetttings()"
                [ngModel]="defaultSettings?.CashOutReportType"
                (ngModelChange)="defaultSettings.CashOutReportType = $event">
          <option *ngFor="let i of reports?.cashoutsReport.reports" value="{{i.ReportId}}">{{i.Description}}</option>
        </select>
      </div>
    </div>
  </div>
  <!--<div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <b> Account number</b>
        <select class="form-control" (change)="addAccount($event.target.value)">
          <option value="-1">Select</option>
          <option *ngFor="let account of userAccounts; i as index" value="{{account.Number}}">{{account.Name}}</option>
        </select>
      </div>
    </div>
  </div>-->

  <div class="row" *ngIf="CanCancelOutboundReceipts=='True'">
    <div class="col-md-4">
      <div class="form-group">
        <user-account-search [searchKey1]="'Number'" [searchKey2]="'Name'" (account)="addAccount($event)"></user-account-search>
      </div>
    </div>
  </div>

  <div *ngIf="gridAccounts.length>0" class="responsive-table">

    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>{{ 'common.accountNumber' | translate }}</th>
          <th>{{ 'common.accountName' | translate }}</th>
          <th>{{ 'common.isDefault' | translate }}</th>
          <th>{{ 'common.action' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let account of gridAccounts; i as index">
          <td>{{account?.Number}}</td>
          <td>{{account?.Name}}</td>
          <td>
            <div class="form-group">
              <input type="radio" (click)="chooseDefaultAccount(account.Number)" name="defaultAccount()" checked="{{account.IsDefault ? 'checked' : '' }}" />
            </div>
          </td>
          <td><button *ngIf="gridAccounts.length>1 || type==1" class="btn btn-primary" (click)="removeAccount(account.Number)"><i class="armx-trash"></i></button></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
